export const getApdex = {
  variable: '$serviceId: ID!',
  query: `
  Int: getApdex(serviceId: $serviceId)`
};

export const createApdex = {
  variable: '$apdexCreationReq: ApdexCreation!',
  query: `
  appConfigurationResponse: createApdexForService(apdexCreationReq: $apdexCreationReq) {
    id: id
    errorReason: errorReason
}`
};

export const getDataRetentionPolicy = {
  variable: '$serviceId: ID!',
  query: `
  dataRetentionResponse: getDataRetentionPolicy(serviceId: $serviceId) {
    saveAllErrors
    minTraceLatency
    maxSpansPerTraces
    minDbQueryLatency
  }`
};

export const createDataRetentionPolicy = {
  variable: '$dataRetentionRequest: DataRetentionPolicyCreation!',
  query: `
  appConfigurationResponse: createDataRetentionPolicy(dataRetentionRequest: $dataRetentionRequest) {
    id: id
    errorReason: errorReason
    message: message
}`
};

export const getTransactionApplicationData = {
  variable: '$from: Int, $limit: Int, $sortBy: ApplicationTransactionSortKey, $order: SortOrder, $serviceId: String!',
  query: `
  resp: getAllApplications(from: $from, limit: $limit, sortBy: $sortBy, order: $order, serviceId: $serviceId,) {
    applicationTransactions {
      applicationName
      numberOfSegments
      transactionId
      uriPosition
      createdAt
    }
    total
}`
};

export const getTransactionEndpointData = {
  variable: '$from: Int, $limit: Int, $sortBy: EndpointSortKey, $order: SortOrder, $serviceId: String!, $endpointTransactionType: EndpointTransactionType!',
  query: `
  resp: getAllEndpoints(from: $from, limit: $limit, sortBy: $sortBy, order: $order, serviceId: $serviceId, endpointTransactionType: $endpointTransactionType) {
    endpointTransactions {
      name
      priority
      regularExpression
      transactionId
      createdAt
      operationType
    }
    total
}`
};

export const getTransUpdateorDeleteApplData = {
  variable: '$applicationRequest: ApplicationTransactionRequest!',
  query: `
  resp: mutateApplicationTransaction(applicationRequest: $applicationRequest) {
    id
    errorReason
  }`
};

export const getTransUpdateorDeleteEndpointData = {
  variable: '$endpointRequest: EndpointRequest!',
  query: `
  resp: mutateEndpointTransaction(endpointRequest: $endpointRequest) {
    id
    errorReason
  }`
};

export const queryValidationData = {
  variable: '$creationRequest: QueryValidationRequest',
  query: `
  resp: mutateValidateQuery(creationRequest: $creationRequest) {
    status
    value
    response
  }`
};

export const queryValidationStatus = {
  variable: '$queryId: String!',
  query: `
    dbmCustomQueryStatus(queryId: $queryId) {
      status
      value
      response
  }`
};

export const saveQueryInfo = {
  variable: '$creationRequest: QueryValidationRequest',
  query: `
  resp: mutateValidateQuery(creationRequest: $creationRequest) {
    status
    value
    response
  }`
};

export const queryTableInfo = {
  variable: '$pagination: Pagination, $keyword: String!',
  query: `
  queryValues: displayQuery(pagination: $pagination, keyword: $keyword) {
    queryValues {
      query
      metricName
      status
      value
      time
      type
      status
      serviceId
      databaseName
      serviceName
        }
        total
      }`
};

export const getRunQueryInfo = {
  variable: '$metricName: String!',
  query: `
  runQuery(metricName: $metricName) {
    query
    value
    time
    }`
  };

export const getAIEnableData = {
  variable: '$request: AIEnablerRequest!',
  query: `
  checkAIEnablement: checkAIEnablement(request: $request) {
    success
    enabledAI
    message
  }`
};

export const getInstancesList = {
  variable: ['$condition: ScopedMetaDataRequest!'],
  query: `
  response: readAggregatedScopedMetrics(condition: $condition) {
    records {
      name
      id
    }
    total
  }`,
};

export const enableCodeProfile = {
  variable: ['$condition: ContinuesProfileDashboardRequest!'],
  query: `
  response: createOrUpdateProfile(condition: $condition) {
    errorReason
    id
    status
  }`
};

export const deleteCodeProfile = {
  variable: ['$condition:ContinuesProfileDashboardRequest!'],
  query: `
  response: deleteProfiling(condition: $condition) {
    message,
    id,
    status
}`,
};

export const getCodeProfileInstance = {
  variable: ['$request: ContinuesProfileDashboardRequest!'],
  query: `
  response: findCodeProfile(request: $request) {
    id,
    status,
    displayMsg,
    message,
    isQualifiedVersion
    total
    continuesProfileRespList  {
        metaId
        serviceId
        instanceId
        enable
        profilesList
        createdBy
        modifiedBy
        instanceName
        samples
        timePeriod
        startTime
        endTime
    }
}`,
};
